// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import * as common from '@common/index';
import Utils from '@common/utils/index.js'
import '@assets/css/elementui.css';
import '@assets/css/base.css';
import '@assets/css/page.css';

// 引入富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)

import { quillEditor } from "vue-quill-editor"; // 导入quillEditor组件


Vue.config.productionTip = false
common.use(Vue);

new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js